import { FLOATING_RESOURCE_ADD_MENU_OPTION } from 'components/FloatingResourceAddMenu/hooks/useData/constants';

import { useFloatingResourceAddContext } from 'hooks/useFloatingResourceAddContext';

import useTranslation from './hooks/useTranslation';

import type {
    FloatingResourceAddOpenRequest,
    UseChildCreationParams,
    UseChildCreationReturn
} from './types';

const useChildCreation = (params: UseChildCreationParams): UseChildCreationReturn => {
    const { ADD_BOUNDARY, ADD_FARM, ADD_FIELD } = useTranslation();
    const { requestOpen } = useFloatingResourceAddContext();

    const buildOpenRequest = (): FloatingResourceAddOpenRequest => {
        if (params.parentType === 'client') {
            return {
                defaultValues: {
                    client: {
                        label: params.parentData?.name ?? '',
                        value: params.parentData?.id ?? ''
                    }
                },
                resource: FLOATING_RESOURCE_ADD_MENU_OPTION.FARM
            };
        }

        if (params.parentType === 'farm') {
            return {
                defaultValues: {
                    client: {
                        label: params.parentData?.clientName ?? '',
                        value: params.parentData?.clientId ?? ''
                    },
                    farm: {
                        label: params.parentData?.name ?? '',
                        value: params.parentData?.id ?? ''
                    }
                },
                resource: FLOATING_RESOURCE_ADD_MENU_OPTION.FIELD
            };
        }

        return {
            defaultValues: {
                client: {
                    label: params.parentData?.clientName ?? '',
                    value: params.parentData?.clientId ?? ''
                },
                farm: {
                    label: params.parentData?.parcelName ?? '',
                    value: params.parentData?.parcelId ?? ''
                },
                field: {
                    label: params.parentData?.name ?? '',
                    value: params.parentData?.id ?? ''
                }
            },
            resource: FLOATING_RESOURCE_ADD_MENU_OPTION.BOUNDARY
        };
    };

    const menuText = {
        client: ADD_FARM,
        farm: ADD_FIELD,
        field: ADD_BOUNDARY
    };

    const handleOpen = () => {
        requestOpen(buildOpenRequest());
    };

    const menuItem = {
        onClick: handleOpen,
        text: menuText[params.parentType]
    };

    return {
        menuItem
    };
};

export default useChildCreation;
